/**
 * Корневой компонент.
 *
 * Слои (снаружи внутрь):
 *   QueryClientProvider → UiThemeProvider → AuthProvider → RouterProvider
 *
 * - QueryClient    — общий для всего приложения (TanStack Query)
 * - UiThemeProvider — дизайн-система КОММА: data-theme на <html> + light/dark
 * - AuthProvider   — глобальный user-state + bootstrap refresh
 * - Router         — TanStack Router, file-based routes; гарды смотрят
 *                    в useAuth() через React Context — пере-рендер происходит
 *                    автоматически при смене статуса.
 */

import { useState } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { ThemeProvider as UiThemeProvider } from '@/shared/theme/ThemeContext';
import { AuthProvider } from '@/auth/AuthContext';
import { routeTree } from '@/routeTree.gen';

const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

export default function App() {
  // Один QueryClient на всё время жизни приложения
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 30_000,
            refetchOnWindowFocus: false,
            retry: 1,
          },
        },
      }),
  );

  return (
    <QueryClientProvider client={queryClient}>
      <UiThemeProvider>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </UiThemeProvider>
    </QueryClientProvider>
  );
}
